import { entity, list } from "./base";
import { concatModules } from "@/utility";

const initialEntity = {
  maker_id: null,
  dish_name: null,
  dish_name_kana: null,
  internal_recipe_id: null,
  description: null,
  cooking_time: null,
  calorie: null,
  cost: null,
  tips: null,
  procedure: [""],
  category: [],
  product_ids: [],
  materials: [{"name": "", "amount": 0, "unit": "" }],
  keywords: [],
  images: [""],
  published: 1,
  user_plan_only: 0,
  sample_paid: null,
  sample_price: null
};

const recipeModule = {
  state: {
    condiments: []
  },
  mutations: {
    fetchedCondiments(state, {payload}) {
      state.condiments = payload
    }
  },
  actions: {
    condiments({ commit }, { recipe_id }) {
      const store = this;
      return new Promise((resolve, reject) => {
        store.$axios
          .get(`/recipes/condiments/${recipe_id}`)
          .then((response) => {
            commit("fetchedCondiments", {
              payload: response.data.data
            });

            resolve();
          })
          .catch((error) => {
            commit("failed", { error });

            reject(error);
          });
      });
    },
  },
  getters: {
    condiments(state) {
      return state.condiments || [];
    }
  }
};

const listModule = list("recipes");

export const recipes = {
  namespaced: true,
  modules: {
    list: concatModules(listModule, recipeModule),
    entity: entity("recipes", initialEntity)
  }
};
